import request from '@/utils/request'

/**
 * 获取报告单信息
 * @param data
 * @returns {*}
 */
export function getReportInfo(data) {
  return request({
    url: '/api/an/worker/getReportInfo',
    method: 'get',
    params: data
  })
}

/**
 * 获取报告单列表
 * @param data
 * @returns {*}
 */
export function getReportList(data) {
  return request({
    url: '/api/an/worker/getReportList',
    method: 'get',
    params: data
  })
}

/**
 * 创建更新报告
 * @param data
 * @returns {*}
 */
export function createOrUpdateReport(data) {
  return request({
    url: '/api/an/worker/createOrUpdateReport',
    method: 'post',
    data: data
  })
}

/**
 * 获取模板列表
 * @returns {*}
 */
export function getReportTemplateList() {
  return request({
    url: '/api/an/worker/getReportTemplateList',
    method: 'get'
  })
}

export function getCountPdf(data) {
  return request({
    url: '/api/reportPdf',
    method: 'get',
    params: data
  })
}

export function createOrderAndReport(data) {
  return request({
    url: '/api/an/worker/createOrderAndReport',
    method: 'post',
    data: data
  })
}


export function getSameAppoSignList(data) {
  return request({
    url: '/api/an/worker/getSameAppoSignList',
    method: 'get',
    params: data
  })
}

export function getReportCompletedTime(data) {
  return request({
    url: '/api/an/worker/completed-time',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js